import { render, staticRenderFns } from "./storeMonthNumStatistic.vue?vue&type=template&id=c922242e&scoped=true"
import script from "./storeMonthNumStatistic.vue?vue&type=script&lang=js"
export * from "./storeMonthNumStatistic.vue?vue&type=script&lang=js"
import style0 from "./storeMonthNumStatistic.vue?vue&type=style&index=0&id=c922242e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c922242e",
  null
  
)

export default component.exports